module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Bold-8d99b7d0.woff2";